import EventClass from "common/utils/ui/event-class";

export default class MobileBackMenuClass extends EventClass {
  #props = {};

  #stack = [];

  constructor(
    props = {
      headerBackTextSelector: "",
      inlineBackSelector: ""
    }
  ) {
    super(props);
    this.#props = props;
  }

  get #$headerBack() {
    return document.querySelector(this.#props.eventSelector);
  }

  get #$headerBackLabel() {
    return document.querySelector(this.#props.headerBackTextSelector);
  }

  #fillLabel() {
    if (this.#$headerBackLabel)
      this.#$headerBackLabel.textContent = this.#stack.length > 0 ? this.#stack.at(-1) : "";
  }

  callbackForwardButton(event, $button) {
    if (!event.isTrusted) return; // Ignore synthetic events

    this.#$headerBack?.classList.remove("hidden");
    const label = $button.dataset.category || $button.textContent.trim();
    this.#stack.push(label);
    this.#fillLabel();
  }

  event() {
    if (this.#stack.length > 0) {
      const level = this.#stack.length;
      const category = this.#stack.pop();
      this.#fillLabel();

      const $back = document.querySelector(
        `${this.#props.inlineBackSelector}[data-category="${category}"][data-direction="back"][data-level="${level}"]`
      );
      const $firstBack = document.querySelector(
        `${this.#props.inlineBackSelector}[data-direction="back"][data-level="1"]`
      );
      const backEvent = new Event("click", { bubbles: true, cancelable: true });
      ($back || $firstBack)?.dispatchEvent(backEvent); // Trigger the back button click event
      if (!$back) this.resetBackButton(); // If no back button was found, reset the back button state
    }

    if (this.#stack.length === 0) {
      this.#$headerBack?.classList.add("hidden");
    }
  }

  resetBackButton() {
    this.#stack = [];
    this.#$headerBack?.classList.add("hidden");
  }
}
